import NotificationListItem from './NotificationListItem';

export default NotificationListItem;